/*
  Festegiatu - fg-core.js
  Nucleo compartido de las apps. Storage, consentimiento, track y lead.
  Cada app (fg-seating.js, fg-checklist.js, ...) se monta encima de esto y
  nunca duplica esta logica.

  Clave unica de estado: festegiatu_event_v1. Las apps escriben solo sus
  campos y no pisan los de las demas.
*/
window.FG = window.FG || {};

(function (FG) {
  'use strict';

  var KEY = 'festegiatu_event_v1';
  var memory = null;

  function canStore() {
    try {
      var t = '__fg__';
      window.localStorage.setItem(t, '1');
      window.localStorage.removeItem(t);
      return true;
    } catch (e) {
      return false;
    }
  }

  var HAS_LS = canStore();

  FG.storageAvailable = HAS_LS;

  FG.read = function () {
    if (!HAS_LS) return memory ? clone(memory) : {};
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return {};
      var parsed = JSON.parse(raw);
      return (parsed && typeof parsed === 'object') ? parsed : {};
    } catch (e) {
      return {};
    }
  };

  /* Merge superficial: solo toca las claves que le pasas. */
  FG.write = function (patch) {
    var next = FG.read();
    for (var k in patch) {
      if (Object.prototype.hasOwnProperty.call(patch, k)) next[k] = patch[k];
    }
    if (!HAS_LS) {
      memory = next;
      return next;
    }
    try {
      window.localStorage.setItem(KEY, JSON.stringify(next));
    } catch (e) {
      memory = next;
    }
    return next;
  };

  FG.clear = function (keys) {
    if (!keys) {
      memory = null;
      if (HAS_LS) {
        try { window.localStorage.removeItem(KEY); } catch (e) {}
      }
      return;
    }
    var next = FG.read();
    for (var i = 0; i < keys.length; i++) delete next[keys[i]];
    if (!HAS_LS) { memory = next; return; }
    try { window.localStorage.setItem(KEY, JSON.stringify(next)); } catch (e) { memory = next; }
  };

  function clone(o) {
    try { return JSON.parse(JSON.stringify(o)); } catch (e) { return {}; }
  }
  FG.clone = clone;

  FG.uid = function (prefix) {
    return (prefix || 'id') + '-' + Math.random().toString(36).slice(2, 9);
  };

  FG.debounce = function (fn, ms) {
    var t;
    return function () {
      var args = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, args); }, ms || 200);
    };
  };

  FG.escape = function (s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  };

  /* Consentimiento. Ninguna herramienta gratuita pide email para usarse:
     esto solo se consulta al guardar, enviar o compartir un resultado. */
  FG.consent = {
    get: function () { return FG.read().consent === true; },
    set: function (v) { FG.write({ consent: v === true }); }
  };

  /* 14.09.2026: si una app ya recogio el email (formulario fg-lead-form
     enviado con exito, ver mas abajo), esto se recuerda para no volver a
     pedirlo. Se guarda en top-level, no dentro del bloque de una app
     concreta, porque el lead es del visitante, no de una app en particular. */
  FG.leadCaptured = {
    get: function () { return FG.read().leadCaptured === true; },
    set: function (v) { FG.write({ leadCaptured: v === true }); }
  };

  /* track() es deliberadamente pasivo: empuja al dataLayer si existe y no
     carga ningun script de terceros por su cuenta. */
  FG.track = function (name, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'fg_' + name, fg: data || {} });
    } catch (e) {}
  };

  /* 14.09.2026, festegiatu-shopify-dev: FG.submitLead queda en desuso.
     Achraf reporto el 13.09 y otra vez el 14.09 que el email daba error de
     captcha al enviarlo. La causa real (documentada en snippets/fg-lead-
     form.liquid y en Notion, tarea Sitzplan-Planer): el formulario nativo
     vivia oculto y este metodo lo enviaba el mismo por programa, sin que la
     persona lo viera ni tocara. Ese patron es justo lo que un filtro
     antispam esta pensado para bloquear. La correccion no es un truco de JS
     mejor, es no ocultar el formulario: fg-lead-form.liquid ahora pinta un
     <form> real y visible, con su propio boton de envio, y la app lo mueve
     de sitio en el DOM en vez de sustituirlo. Con eso el envio es un envio
     real de la persona y no hace falta nada de lo de aqui abajo.
     Esta funcion se deja, simplificada y sin la llamada a
     "Shopify.captcha.protect" que se anadio el 13.09 (no es una API publica
     documentada de Shopify: probablemente no hacia nada y daba una falsa
     sensacion de estar cubriendo el caso), solo por si una app futura
     todavia necesita enviar un formulario por programa desde JS. No se
     recomienda: el patron correcto es el de fg-lead-form.liquid. */
  FG.submitLead = function (email, formId) {
    var form = document.getElementById(formId || 'fg-lead-native');
    if (!form) return false;
    var input = form.querySelector('input[type="email"]');
    if (!input) return false;
    input.value = email;
    FG.track('lead_submit', { form: formId });
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
    return true;
  };
})(window.FG);
